import React, { useRef, useEffect, useState, useMemo, memo } from 'react';
import { useSelector } from 'react-redux';
import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';
import GraphemeSplitter from 'grapheme-splitter';
import wordList from 'an-array-of-english-words';
import wordMap from '../../../src/_helpers/wordMap.json';
import commonWords from 'common-words';
import translateFile from '../../Loc/TranslateFile'
import { getStoredValue } from "../../_helpers/storageHelper";

const CustomKeyboard = ({
    handleVisitorChange,
    currentField,
    fields,
    onInputChange,
    onKeyPress,
    inputs,
    inputValue,
    setShowBoard,
    handleCancel,
    setCurrentField,
    setInputs,
    setErrorMessage,
    type,
    isPassword = false,
    placeholder,
    placeholderList = {},
    IsEmojiEnabled = false,
    fromKioskSetup = false,
    setValues, visitors,
    isonchangefunction = false,
    requireFields = [],
    allFields = [],
    setrequireFields,
    isTabfunction = true,
    isEnterfunction = false,
    isTabKey = true,
    isEnterKey = true,
    isECardEmojiEnabled = false,
    isECard = false,
    isSuggestionsEnabled = true,
    maxCharacter
}) => {
    const keyboardRef = useRef(null);
    const [suggestions, setSuggestions] = useState([]);
    const currentLang = translateFile()
    // Number Fields
    const numericFields = useMemo(() => [
        "childSupportAmount", "priorEmployment", "charges", "AuthorizationCharges",
        "applicationYear", "month", "cellPhone", "workPhone", "cell", "dobMonth", "dobDay", "dobYear",
        "day", "month", "date", "year", "applicationDay", "AutorizationDay", "AutorizationMonth", "AutorizationYear",
        "arrestYear", "assistancePhone", "arrestDay", "arrestMonth", "year", "dob",
        "phoneNo", "applicationMonth", "offenseMonth", "offenseDay", "offenseYear", "courtMonth", "courtDay", "courtYear",
        "homePhone", "cellPhone", "workPhone", "cell", "ssnFirst", "ssnSecond", "ssnThird", "guardianTelephone", "spouseIncome", "childrenAges",
        "lengthOfJob", "netIncome", "supportAmount", "workCompAmount", "benefitsAmount", "incomeInJailAmount", "childSupportObligation",
        "workCompensationAmount", "cashValue", "vehicleEstValue", "equityValue", "courtOrderedPayment", "TotalBondAmount", "caseTotal", "zip"
    ], []);

    const [isEmojiLayout, setIsEmojiLayout] = useState(false);
    const [caps, setcaps] = useState(placeholder == "ENTER VERIFICATION CODE" ? true : false);
    const { loginDetails } = useSelector(state => state.kioskLogin);
    const storedLoginDetails = getStoredValue("loginDetails") || loginDetails;
    const [cursorPosition, setCursorPosition] = useState(0);
    const [isCursorEnd, setIsCursorEnd] = useState(true);
    // Helper function to shuffle an array
    const shuffleArray = (array) => {
        const shuffledArray = [...array];
        for (let i = shuffledArray.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
        }
        return shuffledArray;
    };

    const shuffleLayout = () => {
        const shuffledNumbers = shuffleArray("1 2 3 4 5 6 7 8 9 0".split(' '));
        return {
            default: [
                shuffledNumbers.slice(0, 5).join(' '), // First row
                shuffledNumbers.slice(5).join(' '), // Second row
                '{prev} {accept} {cancel} {bksp} {next}', // Control buttons row
            ],
        };
    };

    const [shuffledLayout, setShuffledLayout] = useState(() =>
        storedLoginDetails?.IsKS == 1
            ? shuffleLayout() // Initialize with shuffled layout if IsKS is 1
            : {
                default: [
                    '1 2 3 4 5',
                    '6 7 8 9 0',
                    '{prev} {accept} {cancel} {bksp} {next}',
                ],
            }
    );

    useEffect(() => {
        if (keyboardRef.current) {
            keyboardRef.current.setInput(currentField ? inputs[currentField] : inputValue);
        }
    }, [currentField, inputs]);

    const numericLayout = useMemo(() => ({
        default: [
            currentField == "priorEmployment" ? "$ 1 2 3" : "1 2 3",
            currentField == "priorEmployment" ? "4 5 6 7" : "4 5 6",
            currentField == "priorEmployment" ? "8 9 / -" : (currentField == "childrenAges" || currentField == "charges" || currentField == 'caseTotal') ? "7 8 9 ," : (currentField == "courtOrderedPayment" || currentField == "spouseIncome"
                || currentField == 'benefitsAmount' || currentField == 'TotalBondAmount' || currentField == 'vehicleEstValue' || currentField == 'cashValue' || currentField == "workCompensationAmount" || currentField == "childSupportAmount" || currentField == "netIncome" || currentField == 'incomeInJailAmount') ? "7 8 9 ." : "7 8 9",
            handleVisitorChange ? "0 / {bksp} {cancel}" : "0 {bksp} {cancel}",
            "{prev} {accept} {next}"
        ]
    }), [currentField]);


    // All Input Layout
    const textinputKeys = useMemo(() => [
        "1 2 3 4 5 6 7 8 9 0",
        "Q W E R T Y U I O P",
        "A S D F G H J K L",
        "Z X C V B N M",
        `{prev} {caps} {accept} {space} {cancel} {bksp}${((currentField === "writeMessage" && IsEmojiEnabled) || isECardEmojiEnabled) ? ' {emojiSwitch}' : ''} {next}`
    ], [currentField]);

    const shuffleTextInputKeys = useMemo(() => {
        // Split fixed keys into rows
        const numericRow = textinputKeys[0].trim().split(' ');
        const firstAlphaRow = textinputKeys[1].trim().split(' ');
        const secondAlphaRow = textinputKeys[2].trim().split(' ');
        const thirdAlphaRow = textinputKeys[3].trim().split(' ');
        const dynamicRow = textinputKeys[4].trim().split(' ');

        // Shuffle each row only when necessary (do not shuffle if just toggling Caps)
        // const shuffledNumericRow = storedLoginDetails?.IsKS == 1 ? shuffleArray(numericRow).join(' ') : (numericRow).join(' ');
        // const shuffledFirstAlphaRow = storedLoginDetails?.IsKS == 1 ? shuffleArray(firstAlphaRow).join(' ') : (firstAlphaRow).join(' ');
        // const shuffledSecondAlphaRow = storedLoginDetails?.IsKS == 1 ? shuffleArray(secondAlphaRow).join(' ') : (secondAlphaRow).join(' ');
        // const shuffledThirdAlphaRow = storedLoginDetails?.IsKS == 1 ? shuffleArray(thirdAlphaRow).join(' ') : (thirdAlphaRow).join(' ');
        const shuffledNumericRow = (numericRow).join(' ');
        const shuffledFirstAlphaRow = (firstAlphaRow).join(' ');
        const shuffledSecondAlphaRow = (secondAlphaRow).join(' ');
        const shuffledThirdAlphaRow = (thirdAlphaRow).join(' ');
        const shuffledDynamicRow = dynamicRow.join(' ');

        // Apply Caps Lock (Uppercase / Lowercase based on `caps` state)
        const applyCaps = (row) => caps ? row.toUpperCase() : row.toLowerCase();

        return [
            `! ${shuffledNumericRow} -`, // Numeric row with @ and -
            isTabKey ? `{⇥Tab} ${applyCaps(shuffledFirstAlphaRow)}` : `${applyCaps(shuffledFirstAlphaRow)}`,
            `${applyCaps(shuffledSecondAlphaRow)} ${placeholder == "Search.." ? ', /' : ','}`, // Second alpha row with Caps applied
            isEnterKey ? `${applyCaps(shuffledThirdAlphaRow)} ? . {enter}` : `${applyCaps(shuffledThirdAlphaRow)} ? .`, // Third alpha row with Caps applied
            `${shuffledDynamicRow}` // Dynamic row
        ];
    }, [textinputKeys, caps]);  // Depend on `caps` to trigger re-render on Caps lock toggle

    // Email Input Layout
    const emailinputKeys = useMemo(() => [
        "1 2 3 4 5 6 7 8 9 0",
        "Q W E R T Y U I O P",
        "A S D F G H J K L",
        "Z X C V B N M",
        `{prev} @ .com . {caps} {accept} {cancel} {bksp}${((currentField === "writeMessage" && IsEmojiEnabled) || isECardEmojiEnabled) ? ' {emojiSwitch}' : ''} {next}`
    ], [currentField]);

    const shuffleEmailInputKeys = useMemo(() => {
        // Split fixed keys into rows
        const numericRow = emailinputKeys[0].trim().split(' ');
        const firstAlphaRow = emailinputKeys[1].trim().split(' ');
        const secondAlphaRow = emailinputKeys[2].trim().split(' ');
        const thirdAlphaRow = emailinputKeys[3].trim().split(' ');
        const dynamicRow = emailinputKeys[4].trim().split(' ');

        // Shuffle each row only when necessary (do not shuffle if just toggling Caps)
        // const shuffledNumericRow = storedLoginDetails?.IsKS == 1 ? shuffleArray(numericRow).join(' ') : (numericRow).join(' ');
        // const shuffledFirstAlphaRow = storedLoginDetails?.IsKS == 1 ? shuffleArray(firstAlphaRow).join(' ') : (firstAlphaRow).join(' ');
        // const shuffledSecondAlphaRow = storedLoginDetails?.IsKS == 1 ? shuffleArray(secondAlphaRow).join(' ') : (secondAlphaRow).join(' ');
        // const shuffledThirdAlphaRow = storedLoginDetails?.IsKS == 1 ? shuffleArray(thirdAlphaRow).join(' ') : (thirdAlphaRow).join(' ');
        const shuffledNumericRow = (numericRow).join(' ');
        const shuffledFirstAlphaRow = (firstAlphaRow).join(' ');
        const shuffledSecondAlphaRow = (secondAlphaRow).join(' ');
        const shuffledThirdAlphaRow = (thirdAlphaRow).join(' ');
        const shuffledDynamicRow = dynamicRow.join(' ');

        // Apply Caps Lock (Uppercase / Lowercase based on `caps` state)
        const applyCaps = (row) => caps ? row.toUpperCase() : row.toLowerCase();

        return [
            `${shuffledNumericRow} -`, // Numeric row with @ and -
            `${applyCaps(shuffledFirstAlphaRow)} _`, // First alpha row with Caps applied
            `${applyCaps(shuffledSecondAlphaRow)}`, // Second alpha row with Caps applied
            `${applyCaps(shuffledThirdAlphaRow)}`, // Third alpha row with Caps applied
            `${shuffledDynamicRow}` // Dynamic row
        ];
    }, [emailinputKeys, caps]);  // Depend on `caps` to trigger re-render on Caps lock toggle
      // Emoji Layout
    const emojiLayout = useMemo(() => ({
        default: [
            "😊 😄 😁 😅 😆 😂 🤣 😋 😉 😎 😍 😙 😘 🥰 🤨 😮", // Row 1
            "🙄 😏 😣 😥 😪 😭 😴 😵 🤒 🤕 🤮 🥳 🤭 🤷‍♀️ 🤷‍♂️ 👣", // Row 2
            "💑 👨‍👩‍👧 👨‍👩‍👦 👨‍👩‍👧‍👦 👨‍👩‍👦‍👦 👨‍👩‍👧‍👧 👭 👫 👴 👵 👨 👦 👶 🤴 👸 👍", // Row 3
            "👎 👌 👏 👊 👋 🙏 🤝 🎂 🎉 🎊 🎃 🎄 🎑 🎁 👑 🥉", // Row 4
            "🏆 🎶 🍕 🍔 🍟 🌭 🍦 🍩 🧁 🍫 ☕ 🥂 🍻 🍺 💐 🌺", // Row 5
            "🥀 🌱 🍁 🌟 ⭐ 🌞 🌜 ☔ 🌄 ✈ 🚅 🚌 🚗", // Row 6
            `{prev} {caps} {accept} {space} {cancel} {bksp} {emojiSwitch} {next}`
        ]
    }), []);

    const [layout, setLayout] = useState({ default: shuffleTextInputKeys });

    useEffect(() => {
        const updatedLayout = isEmojiLayout
            ? emojiLayout.default :
            currentField === 'invitePhone' ? [
                '1 2 3 4 5',
                '6 7 8 9 0',
                '{prev} {accept} {cancel} {bksp} {next}',
            ] :
                (currentField === 'LoginId' || currentField === "Pin") ? shuffledLayout?.default
                    : (currentField === 'inviteEmail' ? shuffleEmailInputKeys : shuffleTextInputKeys);

        setLayout({ default: updatedLayout });
    }, [isEmojiLayout, shuffleEmailInputKeys, shuffleTextInputKeys, emojiLayout, currentField,]);

    useEffect(() => {
        const val = type === "Multiple" ? inputs[currentField] : inputValue
        setCursorPosition(val?.length)
    }, [currentField]);

    const handleclose = () => {
        setTimeout(() => {
            setShowBoard(false);
        }, 250);
    }

    const handleclosekeyboard = (button) => {
        if (isECard) {
            onKeyPress(button);
        }
        handleclose();
    }

    const handleKeyPress = (button) => {
        switch (button) {
            case '{accept}':
                handleclosekeyboard(button);
                break;
            case "{⇥Tab}":
                if (isTabfunction) {
                    handleTyping("\t"); // Add a tab character to the input
                }
                else {
                    handleChange("");
                    handleclosekeyboard(button);
                }
                break;
            case '{cancel}':
                handleclosekeyboard(button);
                if (handleCancel) {
                    handleCancel();
                }
                break;
            case '{next}':
                type === "Multiple" ? handleNextField() : handleclosekeyboard(button);;
                break;
            case '{prev}':
                type === "Multiple" ? handlePrevField() : handleclosekeyboard(button);;
                break;
            case '{emojiSwitch}':
                setIsEmojiLayout(!isEmojiLayout);
                break;
            case "{caps}":
                setcaps((prevCaps) => !prevCaps);  // Toggle caps state
                break;
            case '{bksp}':
            case '{bksp}':
                handleBackspace();
                break;
            case '{enter}':
                if (currentField === "writeMessage" || isEnterfunction) {
                    handleTyping("\n");
                }
                break;
            case '{space}':
                handleTyping(" ");
                break;
            default:
                handleTyping(button);
                break;
        }
    };

    const handleTyping = (button) => {
        if (type === "Multiple") {
            const splitter = new GraphemeSplitter();
            const graphemes = splitter.splitGraphemes(inputs[currentField]);
            const updatedGraphemes = [
                ...graphemes.slice(0, cursorPosition),
                button,
                ...graphemes.slice(cursorPosition)
            ];
            const updatedValue = updatedGraphemes.join('');
            setCursorPosition(cursorPosition + 1);
            handleChange(updatedValue);
            updateSuggestions(updatedValue);
        }
        else {
            let prevalue = type === "Multiple" ? inputs[currentField] : inputValue
            const updatedValue = prevalue.slice(0, cursorPosition) + button + prevalue.slice(cursorPosition);
            setCursorPosition(cursorPosition + 1);
            handleChange(updatedValue);
            updateSuggestions(updatedValue);
        }
    }

    const handlePrevField = () => {
        if (setValues) {
            setValues(visitors ? visitors : inputs);
        }
        const currentIndex = fields.indexOf(currentField);
        if (allFields?.length > 0 && currentIndex > 0) {
            const allFieldIndex = allFields.indexOf(currentField);
            const prevField = fields[currentIndex - 1];
            const prevAllField = allFields[allFieldIndex - 1];

            if (prevField === prevAllField) {
                setCurrentField(prevField);
            } else {
                handleclose();
            }
        } else if (currentIndex > 0) {
            setCurrentField(fields[currentIndex - 1]);
        } else {
           handleclose();
        }
    };


    const handleNextField = () => {
        if (setValues) { setValues(visitors ? visitors : inputs) }
        const currentIndex = fields.indexOf(currentField);
        if (allFields?.length > 0 && currentIndex < fields.length - 1) {
            const allFieldIndex = allFields.indexOf(currentField);
            const nextField = fields[currentIndex + 1];
            const nextAllField = allFields[allFieldIndex + 1];

            if (nextField === nextAllField) {
                setCurrentField(nextField);
            } else {
                handleclose();
            }
        } else if (currentIndex < fields.length - 1) {
            setCurrentField(fields[currentIndex + 1]);
        } else {
           handleclose();
        }

    };

    const handleBackspace = () => {
        if (cursorPosition != 0) {
            if (type === "Multiple") {
                var graphemes = findGraphemeClusters(inputs[currentField]);
                for (let i = 0; i < graphemes.length; i++) {
                    if (graphemes[graphemes.length - 1].index < cursorPosition) {
                        graphemes.pop();
                        break;
                    }
                    else {
                        graphemes = [
                            ...graphemes.slice(0, cursorPosition - 1), // Get elements before index 4
                            ...graphemes.slice(cursorPosition)     // Get elements after index 4
                        ];

                        break;
                    }
                }
                const combinedGraphemes = graphemes.map(item => item.segment).join('');
                const updatedValue = combinedGraphemes;
                setCursorPosition(cursorPosition - 1);
                if (isonchangefunction) {
                    onInputChange(currentField, updatedValue);
                }
                if (requireFields?.includes(currentField) && currentField == "ssnFirst") {
                    setErrorMessage((prev) => ({
                        ...prev,
                        [currentField]: updatedValue.length < 3 ? "Required" : "",
                    }));
                }
                else if (requireFields?.includes(currentField) && currentField == "ssnSecond") {
                    setErrorMessage((prev) => ({
                        ...prev,
                        [currentField]: updatedValue.length < 2 ? "Required" : "",
                    }));
                }
                else if (requireFields?.includes(currentField) && currentField == "ssnThird") {
                    setErrorMessage((prev) => ({
                        ...prev,
                        [currentField]: updatedValue.length < 4 ? "Required" : "",
                    }));
                }
                else if (currentField == "netIncome") {
                    setErrorMessage((prev) => ({
                        ...prev,
                        [currentField]: updatedValue?.trim()?.length == 0 ? currentLang?.ValidationSchema?.Form_Field_Required : prev[currentField],
                        "netIncomeType": updatedValue?.trim()?.length == 0 ? "" : currentLang?.ValidationSchema?.Form_Field_Required
                    }));
                    setInputs((prevState) => ({
                        ...prevState,
                        "netIncomeType": updatedValue?.trim()?.length == 0 ? "" : prevState?.netIncomeType
                    }));
                }
                else if (currentField == "vehicleModel") {
                    setErrorMessage((prev) => ({
                        ...prev,
                        [currentField]: updatedValue?.trim()?.length == 0 ? "" : prev[currentField],
                        "vehicleEstValue": updatedValue?.trim()?.length == 0 ? "" : currentLang?.ValidationSchema?.Form_Field_Required
                    }));
                    setInputs((prevState) => ({
                        ...prevState,
                        "vehicleEstValue": updatedValue?.trim()?.length == 0 ? "" : prevState?.vehicleEstValue
                    }));
                    setrequireFields(updatedValue?.trim()?.length > 0 ? [...requireFields, "vehicleEstValue"] : requireFields);

                }
                else if (currentField == "childSupportObligation") {
                    setErrorMessage((prev) => ({
                        ...prev,
                        [currentField]: updatedValue?.trim()?.length == 0 ? "" : prev[currentField],
                        "childSupportObligationType": updatedValue?.trim()?.length == 0 ? "" : currentLang?.ValidationSchema?.Form_Field_Required
                    }));
                    setInputs((prevState) => ({
                        ...prevState,
                        "childSupportObligationType": updatedValue?.trim()?.length == 0 ? "" : prevState?.childSupportObligationType
                    }));
                }
                else if (requireFields?.includes(currentField) && updatedValue.length == 0) {
                    setErrorMessage((prev) => ({
                        ...prev,
                        [currentField]: currentField == "information1" ? currentLang?.ValidationSchema?.Please_Enter_one_Field : currentLang?.ValidationSchema?.Form_Field_Required,
                    }));
                }
                if (handleVisitorChange) { handleVisitorChange(inputs?.visitorOrderNo, currentField, updatedValue); }
                else {
                    setInputs(prevFormData => ({
                        ...prevFormData,
                        [currentField]: updatedValue
                    }));
                }
                updateSuggestions(updatedValue);
                keyboardRef.current.setInput(updatedValue);
            }
            else {
                let prevalue = inputValue
                const updatedValue = prevalue.slice(0, cursorPosition - 1) + prevalue.slice(cursorPosition);
                setCursorPosition(cursorPosition - 1);
                handleChange(updatedValue);
                keyboardRef.current.setInput(updatedValue);
                updateSuggestions(updatedValue);
            }
        }
    };

    const handleChange = (value) => {
        const maxLength = maxCharacter? maxCharacter : getMaxLength(currentField);
        const splitter = new GraphemeSplitter();
        const graphemes = splitter.splitGraphemes(value);
        if (graphemes?.length <= maxLength) {
            // let limitedValue = value.slice(0, maxLength);
            let limitedValue = value
            if (currentField == 'inviterelationShip' || currentField == 'visitorName' || currentField == 'relation')
                limitedValue = limitedValue.replace(/[^a-zA-Z ]/g, '')

            if (isonchangefunction) {
                onInputChange(currentField, limitedValue);
            }

            if (type !== "Multiple") {
                onInputChange(limitedValue);
            } else {
                if (handleVisitorChange)
                    handleVisitorChange(inputs?.visitorOrderNo, currentField, limitedValue);
                else {
                    if (currentField == "ssnFirst") {
                        setErrorMessage((prev) => ({
                            ...prev,
                            [currentField]: limitedValue?.trim()?.length === 3 ? "" : prev[currentField],
                        }));
                    }
                    else if (currentField == "ssnSecond") {
                        setErrorMessage((prev) => ({
                            ...prev,
                            [currentField]: limitedValue?.trim()?.length === 2 ? "" : prev[currentField],
                        }));
                    }
                    else if (currentField == "ssnThird") {
                        setErrorMessage((prev) => ({
                            ...prev,
                            [currentField]: limitedValue?.trim()?.length === 4 ? "" : prev[currentField],
                        }));
                    }
                    else if (currentField == "netIncome") {
                        setErrorMessage((prev) => ({
                            ...prev,
                            [currentField]: limitedValue?.trim()?.length > 0 ? "" : prev[currentField],
                            "netIncomeType": currentLang?.ValidationSchema?.Form_Field_Required
                        }));
                    }
                    else if (currentField == "childSupportObligation") {
                        setErrorMessage((prev) => ({
                            ...prev,
                            [currentField]: limitedValue?.trim()?.length > 0 ? "" : prev[currentField],
                            "childSupportObligationType": currentLang?.ValidationSchema?.Form_Field_Required
                        }));
                    }
                    else if (currentField == "vehicleModel") {
                        setErrorMessage((prev) => ({
                            ...prev,
                            [currentField]: limitedValue?.trim()?.length > 0 ? "" : prev[currentField],
                            "vehicleEstValue": currentLang?.ValidationSchema?.Form_Field_Required
                        }));
                        setrequireFields(limitedValue?.trim()?.length > 0 ? [...requireFields, "vehicleEstValue"] : requireFields);

                    }
                    else {
                        setErrorMessage((prev) => ({
                            ...prev,
                            [currentField]: "",
                        }));
                    }

                    setInputs((prevState) => ({
                        ...prevState,
                        [currentField]: limitedValue
                    }));
                }
            }

            if (keyboardRef?.current) {
                keyboardRef.current.setInput(limitedValue);
            }
        }
    };

    const getMaxLength = (type) => {
        if (placeholder === "ENTER VERIFICATION CODE") {
            return 7;
        }
        else if (placeholder === "Enter Your Answer") {
            return 50;
        }
        switch (type) {
            case "arrestMonth":
            case "arrestDay":
            case "offenseMonth":
            case "offenseDay":
            case "courtMonth":
            case "courtDay":
            case "month":
            case "day":
            case 'ssnSecond':
                return 2;

            case 'ssnFirst':
            case 'lengthOfJob':
                return 3;

            case "arrestYear":
            case "offenseYear":
            case "courtYear":
            case "year":
            case 'ssnThird':
                return 4;

            case 'zip':
            case 'spouseIncome':
            case 'netIncome':
            case 'childSupportObligation':
            case 'incomeInJailAmount':
            case 'childSupportAmount':
            case 'workCompensationAmount':
            case 'benefitsAmount':
            case 'courtOrderedPayment':
            case 'TotalBondAmount':
                return 5;

            case 'invitePhone':
            case 'dob':
            case 'phoneNo':
            case 'homePhone':
            case 'cellPhone':
            case 'workPhone':
            case 'caseNo':
            case 'AuthorizationCharges':
            case 'guardianTelephone':
            case 'assistancePhone':
                return 10;

            case 'cashValue':
            case 'vehicleEstValue':
            case 'equityValue':
                return 13;

            case "Pin":
                return 15;

            case "LoginId":
                return 19;

            case 'relation':
            case 'priorEmployment':
            case 'AuthorizationNumber1':
            case 'AuthorizationNumber2':
            case 'AuthorizationNumber3':
                return 20;

            case 'inviterelationShip':
            case 'inviteFirstName':
            case 'invitelastName':
            case 'visitorName':
            case 'currentCharges':
                return 25;

            case 'countyName':
            case 'court':
            case 'childrenAges':
                return 30;

            case 'city':
            case 'specifyOther':
                return 40;

            case 'answerOne':
            case 'answerTwo':
            case 'answerThree':
            case 'subject':
            case 'streetName':
            case 'otherNames':
            case 'caseNumber':
            case 'charges':
            case 'coDefendants':
            case 'address':
            case 'city':
            case 'race':
            case 'guardianName':
            case 'spouseName':
            case 'spouseEmployedWhere':
            case 'dependents':
            case 'employerDetails':
            case 'jobTitle':
            case 'disabilityType':
            case 'NamePayYourExpense':
            case 'dependentName':
            case 'otherPayments':
            case 'vehicleModel':
            case 'otherAssets':
            case 'PostYourBond':
            case 'BondPersonAddressPhone':
            case 'unusualExpenses':
            case 'caseTotal':
            case 'facilityName':
            case 'assistanceName':
            case 'assistanceAddress':
            case 'AuthorizationName1':
            case 'AuthorizationName2':
            case 'AuthorizationName3':
            case 'otherRelation1':
            case 'otherRelation2':
            case 'otherRelation3':
                return 50;

            case 'otherState':
            case 'information1':
            case 'information2':
            case 'information3':
            case 'information4':
            case 'information5':
                return 60;

            case 'inviteEmail':
                return 70;

            case 'guardianAddress':
                return 100;

            case 'PDSClientDescription':
                return 1000;

            default:
                return 2000;
        }
    };

    // const findGraphemeClusters = (input) => {
    //     const segmenter = new Intl.Segmenter('en', { granularity: 'grapheme' });
    //     return Array.from(segmenter.segment(input));
    // };

    const findGraphemeClusters = (input) => {
        const splitter = new GraphemeSplitter();
        const graphemes = splitter.splitGraphemes(input);
        let index = 0;
        const segments = graphemes.map(grapheme => {
            const segmentInfo = {
                segment: grapheme,
                index: index,
                input: input
            };
            index += grapheme.length;
            return segmentInfo;
        });

        return segments;
    };

    const handleInputClick = (e) => {
        const { target } = e;
        const inputValue = target.value;
        const caretPosition = target.selectionStart;
        if (caretPosition === 0) {
            // Cursor at the start
            setIsCursorEnd(false);
        } else if (caretPosition === inputValue.length) {
            // Cursor at the end
            setIsCursorEnd(true);
        } else {
            // Cursor is in between
            setIsCursorEnd(false);
        }
        const graphemes = findGraphemeClusters(inputValue);
        let graphemeIndex = 0;
        for (let i = 0; i < graphemes.length; i++) {
            if (graphemes[graphemes.length - 1].index < caretPosition) {
                graphemeIndex = caretPosition;
                break;
            }
            else if (graphemes[i].index == caretPosition) {
                graphemeIndex = i;
                break;
            }
        }
        setCursorPosition(graphemeIndex);
    };
    const platform = window.navigator.platform.toLowerCase();
    const isWindows = platform.includes("win");

    const inputProps = {
        value: type === "Multiple" ? inputs[currentField] : inputValue,
        placeholder: placeholderList[currentField] || placeholder || (currentField === "dob" ? "MM/DD/YYYY" : `Enter your ${currentField}`),
        className: "keyboard-input",
        autoComplete: "off",
        onCopy: (e) => e.preventDefault(),
        onPaste: (e) => e.preventDefault(),
        onCut: (e) => e.preventDefault(),
        type: (currentField == "ssnFirst" || currentField == "ssnSecond" || currentField == "ssnThird" || currentField === "Pin" ||
            isPassword || currentField === "verificationCode") ? "password" : "text",
        onClick: handleInputClick,
        inputMode: "none",
        ...(isWindows ? {} : { onFocus: (e) => e.target.blur() })
    };


    const updateSuggestions = (value) => {
        const trimmed = value.trimEnd(); // preserve trailing space info
        const words = trimmed.split(" ");
        const lastWord = words[words.length - 1].toLowerCase();
        const endsWithSpace = value.endsWith(" ");
    
        let suggestions = [];
    
        const topWords = commonWords.map(w => w.word); // frequent words only

        //const currentWord = findWordAtCursor(value, cursorPosition+1).toLowerCase();
        // console.log("currentWord", currentWord);
        // console.log("lastWord", lastWord);
        // Combine both arrays without duplicates
        const combinedWords = [...new Set([...topWords, ...wordList])];

        if (endsWithSpace && wordList.includes(lastWord)) {
            // ✅ Word is complete and user pressed space → show next-word predictions
            suggestions = wordMap[lastWord] || [];
        } else {
            // ⌨️ Still typing the word → show completions from combinedWords
            suggestions = combinedWords
                .filter((word) => word.toLowerCase().startsWith(lastWord.trim()))
                .slice(0, 7);
        }
        setSuggestions(  lastWord    ? suggestions.map(s => (caps ? s.toUpperCase() : s))    : []);

       // setSuggestions(lastWord ? caps ? suggestions?.toUpperCase() : suggestions?.toUpperCase()  : []);
    };

    function replaceLastWordPreservingNewlines(currentText, word) {
        const match = currentText.match(/[\s\S]*?(\S*)$/);
        const prefix = currentText.slice(0, currentText.length - (match?.[1]?.length || 0));
        return prefix + word + " ";
    }
    
    const handleSuggestionClick = (word) => {
        const currentText = currentField ? inputs[currentField] : inputValue;
        const endsWithSpace = currentText.endsWith(" ");
        let newInput = "";

        if (endsWithSpace) {
            newInput = currentText + word + " ";
        } else {
            const result1 = replaceLastWordPreservingNewlines(currentText, word);
            newInput = result1;
        }

        setCursorPosition(newInput.length);
        handleChange(newInput);
        setSuggestions([]);
        if (keyboardRef.current) keyboardRef.current.setInput(newInput);

        updateSuggestions(newInput);
    };

    return (
        <>
            <div
                className={`keyboard-overlay ${fromKioskSetup ? "single-dot-cursor" : ""}`}
            ></div>
            <div className={`${placeholderList[currentField] == currentLang?.Messages?.Msg_placholder ? "keyboard-Top" :"keyboard"} ${fromKioskSetup ? "single-dot-cursor" : ""} ${(currentField === 'invitePhone' || currentField === 'LoginId' || currentField === "Pin" || numericFields.includes(currentField)) ? 'number-keyboard' : ''}`}>

                {(currentField === "writeMessage" || placeholder == currentLang?.Requests?.Description_Placeholder) ? (
                    <textarea
                        {...inputProps}
                        rows={2}
                        style={{ resize: 'none' }}
                        ref={(textarea) => {
                            if (textarea) {
                                textarea.scrollTop = textarea.scrollHeight;
                            }
                        }}
                    />
                ) : (
                    <input {...inputProps} />
                )}
                {(isSuggestionsEnabled && isCursorEnd) && suggestions.length > 0 && (
                    <div className= {(currentField === "writeMessage" || placeholder == currentLang?.Requests?.Description_Placeholder) ? "texareasuggestions-list" : "inputsuggestions-list"}>
                        {suggestions.map((word, index) => (
                            <div key={index} className="suggestion-item" onClick={() => handleSuggestionClick(word)}>
                                {word}
                            </div>
                        ))}
                    </div>
                )}
                <Keyboard
                    keyboardRef={(r) => (keyboardRef.current = r)}
                    layoutName={"default"}
                    layout={numericFields.includes(currentField) ? numericLayout : layout}
                    display={{
                        '{prev}': `<i class="fa-solid fa-chevron-left me-1 fs-5"></i> ${currentLang?.Keyboard?.Prev}`,
                        '{accept}': currentLang?.Keyboard?.Accept,
                        '{cancel}': currentLang?.Keyboard?.Cancel,
                        '{next}': `${currentLang?.Keyboard?.Next} <i class="fa-solid fa-chevron-right ml-1 fs-5"></i>`,
                        '{emojiSwitch}': isEmojiLayout ? currentLang?.Keyboard?.ABC : '😀',
                        '{bksp}': '<i class="fa-solid fa-delete-left"></i>',

                        '{caps}': currentLang?.Keyboard?.Caps,
                        '{space}': currentLang?.Keyboard?.Space,
                        '{enter}': currentLang?.Keyboard?.Enter,
                        '{⇥Tab}': `⇥ ${currentLang?.Keyboard?.Tab}`
                    }}
                    buttonTheme={[
                        { class: "red-keys", buttons: "{prev} {next}" },
                        { class: "green-keys", buttons: "{accept}" },
                        { class: 'fa-icon', buttons: '{bksp}' },
                        { class: "space-key", buttons: "{space}" }
                    ]}
                    // onChange={handleChange}
                    onKeyPress={handleKeyPress ? handleKeyPress : onKeyPress}
                />
            </div>

        </>
    );
};

export default memo(CustomKeyboard);
